import React, { useEffect, useState } from "react";
import {
  Dialog,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import "./WHUserInputModal.css";
import strikethroughImg from "../img/strikethrough-img.png";
import gtcImg from "../img/gtc-img.png";

import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
});

const WHUserInputModal = ({
  visible,
  setVisible,
  startRun,
  preprocessResponse,
  runConfig,
  setRunConfig,
}) => {
  const { t } = useTranslation();
  const [display, setDisplay] = useState("CONTRACT_STRIKETHROUGH");
  const [shouldStartRun, setShouldStartRun] = useState(false);

  function contractStrikethroughNextHandler() {
    if (preprocessResponse?.uploadGtcQuery) {
      setDisplay("GTC_UPLOAD");
    } else if (preprocessResponse?.handleGtcStrikethroughQuery) {
      setDisplay("GTC_STRIKETHROUGH");
    } else {
      setVisible(false);
      startRun();
    }
  }

  function gtcUploadNextHandler() {
    let upload_gtc = !!runConfig.gtc_file;
    setRunConfig((prev) => ({
      ...prev,
      upload_gtc,
    }));
    setShouldStartRun(true);
  }

  function gtcStrikethroughNextHandler() {
    setVisible(false);
    startRun();
  }

  function handleGTCUpload(e) {
    setRunConfig({
      ...runConfig,
      gtc_file: e.target.files[0],
    });
  }

  useEffect(() => {
    if (visible) {
      if (preprocessResponse?.handleContractStrikethroughQuery) {
        setDisplay("CONTRACT_STRIKETHROUGH");
      } else if (preprocessResponse?.uploadGtcQuery) {
        setDisplay("GTC_UPLOAD");
      } else if (preprocessResponse.handleGtcStrikethroughQuery) {
        setDisplay("GTC_STRIKETHROUGH");
      } else {
        setVisible(false);
      }
    }
  }, [visible, preprocessResponse, setVisible]);

  useEffect(() => {
    if (shouldStartRun) {
      setVisible(false);
      startRun();
      setShouldStartRun(false);
    }
  }, [runConfig.upload_gtc, shouldStartRun, startRun, setVisible]);

  return (
    <React.Fragment>
      <Dialog
        open={visible}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {display === "CONTRACT_STRIKETHROUGH" && (
          <div className="wh-input-modal">
            <div className="user-input-img-container">
              <img src={strikethroughImg} alt="Person" className="banner-img" />
            </div>

            <div className="ekm-main-container">
              <h1>{t("doorgehaaldeTekst")}</h1>
              <div className="select-language-container">
                <span className="select-language">
                  {t("vraagDoorgehaaldTekst")}
                </span>
              </div>

              <div className="strike-modal-btns">
                <RadioGroup
                  row={false}
                  value={runConfig?.contractHasStrikethrough}
                  onChange={(e) =>
                    setRunConfig({
                      ...runConfig,
                      contract_has_strikethrough:
                        e.target.value === "YES" ||
                        e.target.value === "UNKNOWN",
                    })
                  }
                >
                  <FormControlLabel
                    value="YES"
                    control={<Radio />}
                    label={t("ja")}
                  />
                  <FormControlLabel
                    value="NO"
                    control={<Radio />}
                    label={t("nee")}
                  />
                  <FormControlLabel
                    value="UNKNOWN"
                    control={<Radio />}
                    label={t("weetIkNiet")}
                  />
                </RadioGroup>
              </div>
              <div>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    mr: 1,
                    textTransform: "none",
                    borderRadius: "40px",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                  onClick={contractStrikethroughNextHandler}
                >
                  {t("Volgende")}
                </Button>
              </div>
            </div>
          </div>
        )}

        {display === "GTC_UPLOAD" && (
          <div className="wh-input-modal">
            <div className="user-input-img-container">
              <img src={gtcImg} alt="GTC" className="banner-img" />
            </div>

            <div className="ekm-main-container">
              <h1>{t("Algemene bepalingen")}</h1>
              <div className="select-language-container">
                <span>{t("vraagAlgemeneBepalingenTekst")}</span>
              </div>
              {runConfig.gtc_file ? (
                <div className="nc-file-details">
                  <span className="nc-upload-file">
                    {runConfig?.gtc_file?.name || ""}
                  </span>
                  <DeleteIcon
                    onClick={() =>
                      setRunConfig({ ...runConfig, gtc_file: null })
                    }
                    sx={{ cursor: "pointer", color: "#0F3A58" }}
                  />
                </div>
              ) : (
                <div>
                  <div className="gtc-upload-field">
                    <Button
                      component="label"
                      color="primary"
                      role={undefined}
                      variant="contained"
                      tabIndex={-1}
                      sx={{
                        border: "2px dashed #2484C848",
                        borderRadius: "8px",
                        padding: "24px",
                        minHeight: "120px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#F9FCFE",
                        backgroundImage: `repeating-linear-gradient(
                            transparent,
                            transparent 8px,
                            #439BD9 8px,
                            #439BD9 12px,
                          )`,
                        width: "120px",
                        backgroundSize: "2px 3px",
                        backgroundPosition:
                          "top left, top right, bottom right, bottom left",
                      }}
                      // disabled={selectedModule === null}
                      startIcon={
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#000",
                            transform: "translateX(4px)",
                          }}
                        >
                          <UploadFileIcon
                            htmlColor="#439BD9"
                            sx={{ marginRight: "0!important" }}
                          />
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#439BD9",
                              fontWeight: 500,
                              textTransform: "none",
                            }}
                          >
                            Upload
                          </span>
                        </div>
                      }
                    >
                      <VisuallyHiddenInput
                        type="file"
                        accept=".pdf,.docx"
                        onChange={handleGTCUpload}
                      />
                    </Button>
                  </div>
                  <br />
                  <br />
                  <span>{t("bestandsFormaat")}: PDF, DOCX</span>
                </div>
              )}
              <Button variant="contained" onClick={gtcUploadNextHandler}>
                {runConfig.gtc_file ? t("start") : t("doorgaanZonderGTC")}
              </Button>
            </div>
          </div>
        )}

        {display === "GTC_STRIKETHROUGH" && (
          <div className="wh-input-modal">
            <div className="user-input-img-container">
              <img src={strikethroughImg} alt="Person" className="banner-img" />
            </div>

            <div className="ekm-main-container">
              <h1>{t("doorgehaaldeTekstGTC")}</h1>
              <div className="select-language-container">
                <span className="select-language">
                  {t("vraagDoorgehaaldTekstGTC")}
                </span>
              </div>

              <div className="strike-modal-btns">
                <RadioGroup
                  row={false}
                  value={runConfig?.hasStrikethrough}
                  onChange={(e) =>
                    setRunConfig({
                      ...runConfig,
                      gtc_has_strikethrough:
                        e.target.value === "YES" ||
                        e.target.value === "UNKNOWN",
                    })
                  }
                >
                  <FormControlLabel
                    value="YES"
                    control={<Radio />}
                    label={t("ja")}
                  />
                  <FormControlLabel
                    value="NO"
                    control={<Radio />}
                    label={t("nee")}
                  />
                  <FormControlLabel
                    value="UNKNOWN"
                    control={<Radio />}
                    label={t("weetIkNiet")}
                  />
                </RadioGroup>
              </div>
              <div>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    mr: 1,
                    textTransform: "none",
                    borderRadius: "40px",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                  onClick={gtcStrikethroughNextHandler}
                >
                  {t("Volgende")}
                </Button>
              </div>
            </div>
          </div>
        )}
      </Dialog>
    </React.Fragment>
  );
};

export default WHUserInputModal;
